export enum TransitionType {
  Unconditional = "Unconditional",
  Conditional = "Conditional",
  Timeout = "Timeout",
}
